import React, { useState, useEffect } from "react";
import { FormHelperText, styled, Typography } from "@mui/material";
import SideBar from "../SideBar/SideBar";
import { Col, Row } from "antd";
import styles from "./payout.module.css"; // Import the CSS file
import Header from "../Header/Header";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import Footer from "../Footer/Footer";
import { useAllProduct } from "../../api-context/commonApiContext";
import { useNavigate } from "react-router-dom";
import BulkPayout from "./BulkPayout";
import Lottie from "lottie-react";
import approved from "./Animation-SuccessfulGIF.json";
import config from "../../service/config";
import FullScreenLoader from "../../reusable/loader/FullScreenLoader";
import OTPInput from "react-otp-input";

const Payout = () => {
  const {
    companyDropdown,
    role,
    makerLimit,
    loading,
    setLoading,
    userId,
    clientId,
    selectedCompanyName,
    selectedEscrowName,
  } = useAllProduct(); // Make sure this is defined in the context
  const [formValues, setFormValues] = useState({
    age: "",
    contact: "",
    paymentMode: "",
    bankAccount: "",
    amount: "",
    transactionNote: "",
    internalNote: "",
  });
  const [uploadedReceipt, setUploadedReceipt] = useState(null);

  const [activeButton, setActiveButton] = useState("transaction");
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [continueButton, setContinueButton] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [uploadedReceipts, setUploadedReceipts] = useState([]);
  const [uploadError, setUploadError] = useState("");
  const [bulkPayout, setBulkPayout] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBeneficiaries = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `${config.node_api_endpoint}/api/beneficiaries?createdByUserId=${userId}&clientId=${clientId}&selectedCompanyName=${selectedCompanyName}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
            },
          }
        );
        const result = await res.json();

        console.log("selectedCompanyName22-->", result, selectedCompanyName);
        if (result.success) {
          console.log("helow");

          const safeCompanyKey = selectedCompanyName?.trim();
          const companyBlock = result?.data?.[0]?.[safeCompanyKey];

          const entries = companyBlock?.entries || [];
          console.log("helow-->", entries);

          setBeneficiaries(entries.sort((a, b) => b.id - a.id));
        } else {
          console.error("Error fetching beneficiaries:", result.message);
        }
      } catch (error) {
        console.error("API error:", error);
      } finally {
        setLoading(false); // ✅ Stop loader
      }
    };

    fetchBeneficiaries();
  }, [selectedCompanyName]);

  useEffect(() => {
    const selected = beneficiaries.find(
      (data) => data.name === formValues.contact
    );
    console.log(selected);

    if (selected) {
      setFormValues((prev) => ({
        ...prev,
        bankAccount: selected.account_number || selected.upi_id, // 👈 new field being updated
      }));
    }
  }, [formValues.contact, beneficiaries]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    let message = "";

    switch (name) {
      case "contact":
        if (!value) message = "Contact is required.";
        break;

      case "bankAccount":
        if (!value) message = "Bank Account / UPI is required.";
        break;

      case "amount":
        if (!value) {
          message = "Amount is required.";
        } else if (
          role.toString() !== "Owner" &&
          Number(value) > Number(makerLimit)
        ) {
          message = "Amount exceeds Maker Limit.";
        } else if (!/^\d+(\.\d{1,2})?$/.test(value)) {
          message = "Enter a valid amount.";
        }
        break;

      case "transactionNote":
        if (!value) message = "Transaction Note is required.";
        break;

      case "internalNote":
        if (!value) message = "Internal Note is required.";
        break;

      default:
        break;
    }

    setErrorMessages((prev) => ({
      ...prev,
      [name]: message,
    }));
  };

  const handleContinueButton = () => {
    const newErrorMessages = {};

    if (!formValues.contact) {
      newErrorMessages.contact = "Contact is required.";
    }

    if (!formValues.bankAccount) {
      newErrorMessages.bankAccount = "Bank Account / UPI is required.";
    }

    if (!formValues.amount) {
      newErrorMessages.amount = "Amount is required.";
    } else if (
      role.toString() !== "Owner" &&
      Number(formValues.amount) > Number(makerLimit)
    ) {
      newErrorMessages.amount = "Amount exceeds Maker Limit.";
    } else if (!/^\d+(\.\d{1,2})?$/.test(formValues.amount)) {
      newErrorMessages.amount = "Enter a valid amount.";
    }

    if (!formValues.transactionNote) {
      newErrorMessages.transactionNote = "Transaction Note is required.";
    }

    if (!formValues.internalNote) {
      newErrorMessages.internalNote = "Internal Note is required.";
    }

    setErrorMessages(newErrorMessages);

    const hasErrors = Object.values(newErrorMessages).some((msg) => msg);
    if (hasErrors) {
      const firstErrorField = Object.keys(newErrorMessages).find(
        (key) => newErrorMessages[key]
      );
      const el = document.querySelector(`[name="${firstErrorField}"]`);
      if (el && el.scrollIntoView) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus();
      }
      return;
    }

    // ✅ No errors: show loader, then mark success
    setLoading(true); // Start loader

    // Simulate processing delay
    setTimeout(() => {
      setPaymentSuccess(true);
      setLoading(false); // Stop loader
    }, 500); // Adjust as needed
  };

  const handleReceiptUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const maxTotalSizeMB = 10;
      const maxTotalSizeBytes = maxTotalSizeMB * 1024 * 1024;

      // Calculate current total size
      const currentTotalSize = uploadedReceipts.reduce(
        (sum, f) => sum + f.size,
        0
      );

      // Calculate total size if we add the new file
      const newTotalSize = currentTotalSize + file.size;

      if (newTotalSize > maxTotalSizeBytes) {
        alert(
          "Total receipt size exceeds 10 MB. Please remove some files or upload smaller ones."
        );
        return;
      }

      setUploadedReceipts((prev) => [...prev, file]);
    }
  };

  const handleDeleteReceipt = (index) => {
    setUploadedReceipts((prev) => prev.filter((_, i) => i !== index));
  };

  const uploadReceiptsWithForm = async () => {
    const formData = new FormData();

    // Append uploaded files
    uploadedReceipts.forEach((file) => {
      formData.append("receipts", file); // multiple files under 'receipts'
    });

    // Append form fields
    formData.append("beneficiary_name", formValues.contact);
    formData.append("bank_account", formValues.bankAccount);
    formData.append("amount", formValues.amount);
    formData.append("transaction_note", formValues.transactionNote);
    formData.append("internal_note", formValues.internalNote);
    formData.append("created_by", role.toString());
    formData.append("approved_by", "");
    formData.append("status", "Pending");
    formData.append("client_id", clientId);
    formData.append("selectedCompanyName", selectedCompanyName);
    formData.append("selectedEscrowName", selectedEscrowName);

    try {
      setLoading(true);
      const res = await fetch(
        `${config.node_api_endpoint}/api/upload-receipts`,
        {
          method: "POST",
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
          body: formData,
        }
      );

      const result = await res.json();
      setLoading(false);
      if (result.success) {
        console.log("Upload success:", result);
        setUploadedReceipts([]);
        setFormValues({
          contact: "",
          bankAccount: "",
          amount: "",
          transactionNote: "",
          internalNote: "",
        });
        // alert("Files and payout details uploaded successfully");
      } else {
        alert("Upload failed: " + result.message);
      }
    } catch (err) {
      setLoading(false);
      console.error("Error:", err);
      alert("Upload failed");
    }
  };

  const fixedLabelSx = {
    inputLabel: {
      sx: {
        color: "#4C4E64 !important",
        "&.Mui-focused": {
          color: "#4C4E64 !important",
        },
        "&.Mui-error": {
          color: "#4C4E64 !important",
        },
      },
    },
  };

  const handleChangeOtp = (value) => {
    const digitsOnly = value.replace(/\D/g, "");
    setOtp(digitsOnly);
  };

  console.log("selectedCompanyName-->", selectedCompanyName);
  return bulkPayout === false ? (
    <div>
      <FullScreenLoader spinning={loading} />
      <div className="d-flex justify-content-between">
        <div className={`${styles.title} mt-5`}>Payout</div>
        <div
          className={`${styles.bulkPayoutButton} mt-5 d-flex justify-content-center align-items-center p-2 gap-2`}
          onClick={() => {
            setBulkPayout(true);
            navigate("/payout/bulkpayout");
          }}
        >
          <img src="/bulkIcon.svg" />
          Bulk Payouts
        </div>
      </div>
      {continueButton ? (
        <>
          <div className={styles.modalBackdrop}>
            <div className={styles.modalContainer}>
              <div className={`d-flex justify-content-center`}>
                <Lottie
                  className={`${styles.httpslottiefilescomanimatIcon} `}
                  animationData={approved}
                  loop={true}
                />
              </div>
              <div className={styles.successMessage}>
                Payout successfully sent for approval
              </div>
              <div className="d-flex justify-content-center gap-3 mt-3">
                <button
                  className={`${styles.transactionsButtons} ${
                    activeButton === "transaction" ? styles.activeButton : ""
                  }`}
                  onClick={() => navigate("/payout-view")}
                >
                  <div className={styles.transactions}>
                    Return to Payout-View
                  </div>
                </button>
                <button
                  className={`${styles.transactionsButtons} ${
                    activeButton === "transaction" ? styles.activeButton : ""
                  }`}
                  onClick={() => {
                    setContinueButton(false);
                    setPaymentSuccess(false);
                  }}
                >
                  <div className={styles.transactions}>Proceed to Payouts</div>
                </button>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className={`mt-5`}>
            <div
              className="w-100 p-5"
              style={{ borderRadius: "12px", border: "1px solid #C0C0C0" }}
            >
              <div className="d-flex justify-content-between gap-2">
                <Box className="w-100">
                  <FormControl fullWidth>
                    <InputLabel
                      id="contact-select-label"
                      sx={{
                        color: "#4C4E64 !important",
                        "&.Mui-focused": { color: "#4C4E64 !important" },
                        "&.Mui-error": { color: "#4C4E64 !important" },
                      }}
                    >
                      Beneficiary Name*
                    </InputLabel>
                    <Select
                      labelId="contact-select-label"
                      id="contact-select"
                      name="contact"
                      value={formValues.contact}
                      onChange={handleChange}
                      label="Beneficiary Name*"
                      error={!!errorMessages.contact}
                      helperText={errorMessages.contact}
                      slotProps={fixedLabelSx}
                    >
                      {beneficiaries.map((data, index) => (
                        <MenuItem key={index} value={data.name}>
                          {data.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText style={{ color: "#DD6060" }}>
                      {errorMessages.contact}
                    </FormHelperText>
                  </FormControl>
                </Box>

                <Box className="w-100">
                  <FormControl fullWidth>
                    <TextField
                      className="w-100"
                      name="bankAccount"
                      label="Bank Ac / UPI"
                      variant="outlined"
                      disabled = {true}
                      value={formValues.bankAccount}
                      onChange={handleChange}
                      // error={!!errorMessages.bankAccount}
                      // helperText={errorMessages.bankAccount}
                      slotProps={fixedLabelSx}
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          cursor: "not-allowed",
                          pointerEvents: "all", // keeps cursor visible
                          backgroundColor:"#F1F1F1",
                          borderRadius: "9px"
                        },
                      }}
                    />
                  </FormControl>
                </Box>
              </div>
              <div className="d-flex justify-content-between mt-4 gap-2">
                <TextField
                  className="w-100"
                  name="amount"
                  label="Amount"
                  variant="outlined"
                  value={formValues.amount}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Allow only digits and one optional decimal with max 2 digits
                    const sanitized = input.replace(/[^0-9.]/g, "");
                    const validDecimal = /^\d*(\.\d{0,2})?$/.test(sanitized);

                    if (validDecimal) {
                      handleChange({
                        target: {
                          name: "amount",
                          value: sanitized,
                        },
                      });
                    }
                  }}
                  onKeyDown={(e) => {
                    // Prevent 'e', 'E', '+', '-', etc.
                    if (
                      ["e", "E", "+", "-"].includes(e.key) ||
                      (e.key === "." && formValues.amount.includes("."))
                    ) {
                      e.preventDefault();
                    }
                  }}
                  inputProps={{
                    inputMode: "decimal",
                    pattern: "[0-9]*",
                  }}
                  error={!!errorMessages.amount}
                  helperText={errorMessages.amount}
                  slotProps={fixedLabelSx}
                />

                <TextField
                  className="w-100"
                  name="transactionNote"
                  label="Transaction Note"
                  variant="outlined"
                  value={formValues.transactionNote}
                  onChange={handleChange}
                  error={!!errorMessages.transactionNote}
                  helperText={errorMessages.transactionNote}
                  slotProps={fixedLabelSx}
                />
              </div>

              <div className="d-flex justify-content-between mt-4">
                <TextField
                  className="w-50"
                  name="internalNote"
                  label="Internal Note"
                  variant="outlined"
                  value={formValues.internalNote}
                  onChange={handleChange}
                  error={!!errorMessages.internalNote}
                  helperText={errorMessages.internalNote}
                  slotProps={fixedLabelSx}
                />
              </div>
              <div className="mt-4 w-50">
                <div
                  style={{
                    border: "1px dashed #C0C0C0",
                    padding: "20px",
                    borderRadius: "12px",
                  }}
                >
                  <h6 className="fw-semibold" style={{ color: "#333" }}>
                    Upload Receipt
                  </h6>

                  {/* Uploaded Files List */}
                  <div>
                    {uploadedReceipts.map((file, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between bg-white p-2 my-2"
                        style={{
                          borderRadius: "8px",
                          border: "1px solid #ECECEC",
                          color: "#333",
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <img
                            src="/receipt-icon.svg"
                            style={{ height: 24, marginRight: 12 }}
                          />
                          {file.name}
                        </div>
                        <img
                          src="/delIcon.svg"
                          style={{ cursor: "pointer", height: 20 }}
                          alt="delete"
                          onClick={() => handleDeleteReceipt(index)}
                        />
                      </div>
                    ))}
                  </div>

                  {/* Upload Trigger */}
                  <label
                    htmlFor="receipt-upload"
                    className="d-flex flex-column align-items-center justify-content-center text-center p-4 mt-2"
                    style={{
                      border: "1px dashed #B0B0B0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      backgroundColor: "#FAFAFA",
                    }}
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <img src="/upload.svg" alt="Upload" />
                      <span
                        style={{
                          color: "#777777",
                          // textDecoration: "underline",
                        }}
                      >
                        Drag & drop the file here or
                      </span>
                      <span
                        style={{
                          color: "#2348AB",
                          textDecoration: "underline",
                        }}
                      >
                        Click to upload
                      </span>
                    </div>
                  </label>
                  <input
                    id="receipt-upload"
                    type="file"
                    style={{ display: "none" }}
                    accept="image/png, image/jpeg, image/jpg, image/webp"
                    onChange={handleReceiptUpload}
                  />
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#888",
                      marginTop: "4px",
                    }}
                    className="d-flex justify-content-center"
                  >
                    + Upload only JPEG Format document
                  </div>
                </div>
                {uploadError && (
                  <div
                    style={{
                      color: "#DD6060",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {uploadError}
                  </div>
                )}
              </div>

              <div>
                {!paymentSuccess ? (
                  <div
                    className={`${styles.continueButton} d-flex justify-content-center align-items-center mousePointer p-2 w-25 mt-4`}
                    onClick={handleContinueButton}
                  >
                    {"Generate OTP"}
                  </div>
                ) : (
                  <div className={`d-flex mt-4`}>
                    <div className="w-100">
                      <>
                        <div className="w-25">
                          <div className={`${styles.otp} mb-4`}>
                            {"Enter Otp"}
                          </div>
                          <OTPInput
                            value={otp}
                            onChange={handleChangeOtp}
                            numInputs={6}
                            renderInput={(props) => (
                              <input
                                {...props}
                                style={{
                                  width: "50px",
                                  height: "48px",
                                  fontSize: "24px",
                                  textAlign: "center",
                                  border: "none",
                                  borderBottom: "2px solid black",
                                  marginRight: "8px",
                                  borderRadius: "0",
                                }}
                              />
                            )}
                            onKeyDown={(e) => {
                              if (
                                !/[0-9]/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>

                        <div
                          className={`${styles.continueButton} d-flex justify-content-center p-2 mt-3 mousePointer w-25`}
                          onClick={async () => {
                            await uploadReceiptsWithForm();
                            setContinueButton(true);
                            setFormValues({});
                          }}
                        >
                          Create Payout
                        </div>
                      </>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  ) : (
    <BulkPayout />
  );
};

export default Payout;
